/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getId } from '@fluentui/react/lib/Utilities';
import { TestPanePredictionStore } from 'src/luis/types/stores/testPane/TestPanePredictionStore';

/**
 * A test pane prediction store factory function.
 */
export const createTestPanePredictionStore = (prediction: Partial<TestPanePredictionStore>): TestPanePredictionStore => ({
    id: getId(),
    mainUtterance: prediction.mainUtterance
});
